// extracted by mini-css-extract-plugin
module.exports = {"form":"InitialSetupScreen_form__1bt1I","form-button":"InitialSetupScreen_form-button__2TDZW","btn":"InitialSetupScreen_btn__3uKBq"};